<template>
  <div class="maincont" id="detail_demand">
    <div id="charts">
      <div class="ef--inner">
        <div id="demand">
          <h2>デマンド監視</h2>
          <p class="subttl">電力デマンド予測 （30分単位）</p>
          <dl class="display_date">
            <template v-if="demandData.demand_time != null">
              <dt>表示日時</dt>
              <dd>
                {{ getYYYY }}年 <span>{{ getMM }}</span
                >月 <span>{{ getDD }}</span
                >日
                <span>{{ getStartTime }}～{{ getEndTime }}</span>
              </dd>
            </template>
            <template v-else>
              <dt>&nbsp;</dt>
            </template>
          </dl>
          <div class="chart_wrap">
            <div id="demand_legend" class="legend"></div>
            <div class="container">
              <p class="label_left">(kW)</p>
              <p class="label_bottom">(分)</p>
              <canvas id="demand_canvas"></canvas>
            </div>
          </div>

          <div class="detailcont" v-if="this.demandGraphType == 3">
            <p class="time" v-if="isLatestGraph">
              <span>{{ currentTime }}</span
              >現在
            </p>
            <div class="level" v-bind:class="alertLevelClass">
              <span v-if="this.demandData.control_status == 0">未制御</span>
              <span v-if="this.demandData.control_status == 1">制御中 (限界制御)</span>
              <span v-if="this.demandData.control_status == 2">制御中 (注意制御)</span>
            </div>
            <ul>
              <li>
                <dl>
                  <dt>目標電力</dt>
                  <dd><span>{{ demandData.contract_power }}</span>kW</dd><br>
                  <dt>限界電力</dt>
                  <dd><span>{{ demandData.limit_power }}</span>kW</dd><br>
                  <dt>注意電力</dt>
                  <dd><span>{{ demandData.caution_power }}</span>kW</dd><br>
                </dl>
              </li>
              <li>
                <dl>
                  <dt>デマンド実績</dt>
                  <dd><span>{{ currentPower }}</span>kW</dd><br>
                  <dt>制御開始</dt>
                  <dd v-if="demandData.air_conditioner_id_count > 0 && alarmTimed > 0"><span>{{ alarmTimed }}</span>分時点</dd>
                  <dd v-else><span>-</span></dd>
                  <br>
                  <dt>制御解除</dt>
                  <dd v-if="demandData.control_finish_time == '-'"><span>{{ demandData.control_finish_time }}</span></dd>
                  <dd v-else-if="demandData.air_conditioner_id_count > 0"><span>{{ demandData.control_finish_time }}</span>分時点</dd>
                  <dd v-else><span>-</span></dd>
                  <br>
                </dl>
              </li>
              <li>
                <dl>
                  <dt>制御効果量</dt>
                  <dt>&nbsp;&nbsp;&nbsp;デマンド</dt>
                  <dd v-if="demandData.air_conditioner_id_count > 0"><span>{{ nowControlPower }}</span>kW</dd>
                  <dd v-else><span>-</span></dd>
                  <br>
                  <dt>&nbsp;&nbsp;&nbsp;使用量</dt>
                  <dd v-if="demandData.air_conditioner_id_count > 0"><span>{{ Math.ceil(nowControlPower / 2) }}</span>kWh</dd>
                  <dd v-else><span>-</span></dd>
                </dl>
              </li>
              <li>
                <dl>
                  <dt>制御履歴</dt>
                  <table style="margin-left:15px;">
                    <thead>
                      <tr>
                        <td style="width:50px;">時限</td>
                        <td style="width:100px; text-align:right;">調整電力</td>
                        <td style="width:120px; text-align:right;">デマンド予測</td>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(item, index) in demandData.history" v-bind:key="index">
                        <td>{{ item.timed }}分</td>
                        <td v-if="item.adjust == '-'" style="text-align:right;">{{ item.adjust }}</td>
                        <td v-else style="text-align:right;">{{ item.adjust }}kW</td>
                        <td style="text-align:right;">{{ item.demand }}kW</td>
                      </tr>
                    </tbody>
                  </table>
                </dl>
              </li>
            </ul>
          </div>

          <div class="detailcont" v-else>
            <p class="time" v-if="isLatestGraph">
              <span>{{ currentTime }}</span
              >現在
            </p>
            <div class="level" v-bind:class="alertLevelClass">
              <span v-if="alertLevelClass == 'level1'"
                >デマンド良好</span
              >
              <span v-if="alertLevelClass == 'level2'"
                >デマンド注意</span
              >
              <span v-if="alertLevelClass == 'level3'"
                >デマンド警報</span
              >
            </div>
            <ul>
              <li>
                <dl>
                  <dt>デマンド実績</dt>
                  <dd>
                    <span v-bind:class="alertLevelClass">{{
                      currentPower
                    }}</span
                    >kW
                  </dd>
                </dl>
              </li>
              <li>
                <dl>
                  <dt>デマンド予測</dt>
                  <dd>
                    <span v-bind:class="alertLevelClass">{{
                      forcastPowor
                    }}</span
                    >kW
                  </dd>
                </dl>
              </li>
              <li v-if="demandGraphType == 2">
                <dl>
                  <dt>警報時デマンド予測</dt>
                  <dd>
                    <span>{{ alarmForcastPowor }}</span
                    >kW
                  </dd>
                </dl>
              </li>
              <li>
                <dl>
                  <dt>デマンド目標値</dt>
                  <dd>
                    <span>{{ demandData.contract_power }}</span
                    >kW
                  </dd>
                </dl>
              </li>
              <li>
                <dl>
                  <dt>警報閾値</dt>
                  <dd>
                    <span>{{ demandData.alarm_threshold }}</span
                    >kW
                  </dd>
                </dl>
              </li>
              <li>
                <dl>
                  <dt>注意閾値</dt>
                  <dd>
                    <span>{{ demandData.caution_threshold }}</span
                    >kW
                  </dd>
                </dl>
              </li>
              <li v-if="demand_control != 0">
                <dl>
                  <dt>必要抑制量</dt>
                  <dd>
                    <span>{{ demand_control }}</span
                    >kW
                  </dd>
                </dl>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div id="demand-tooltip" v-bind:class="alertLevelClass">
    </div>
  </div>
</template>


<script>
/* eslint-disable */
// import Chart from "chart.js";
// import $ from "jquery";
import Store from "../store";
import Axios from "axios";
import moment from "moment";

export default {
  name: "demand",
  data: function() {
    return {
      demandData: {
        demand_time: "",
        last_datetime: "",
        alarm_threshold: 0,
        caution_threshold: 0,
        contract_power: 0,
        power_max: 0,
        power_min: 0,
        measure_instrument: 0,
        air_conditioner_control: false,
        air_conditioner_id_count: 0,
        control_status: 0,
        caution_power: 0,
        limit_power: 0,
        control_finish_time: "",
        history: [],
        measure: [],
        demand: [],
        alarm_demand: [],
        lteMAlarmStatusList: null
      },
      currentPower: 0,
      forcastPowor: 0,
      alarmForcastPowor: 0,
      nowTimed: 0,
      alarmTimed: 0,
      totalControlPower: 0,
      nowControlPower: 0,
      chart: null,
      alertLevelClass: "level0",
      intervalId: null,
      demand_control: 0,
      demandGraphType: 0
    };
  },
  computed: {
    currentTime: function() {
      return moment().format("HH:mm");
    },
    getYYYY: function() {
      return moment
        .utc(this.demandData.demand_time, "YYYY/MM/DD HH:mm:ss")
        .format("YYYY");
    },

    getMM: function() {
      return moment
        .utc(this.demandData.demand_time, "YYYY/MM/DD HH:mm:ss")
        .format("MM");
    },
    getDD: function() {
      return moment
        .utc(this.demandData.demand_time, "YYYY/MM/DD HH:mm:ss")
        .format("DD");
    },
    getStartTime: function() {
      return moment
        .utc(this.demandData.demand_time, "YYYY/MM/DD HH:mm:ss")
        .format("HH:mm");
    },
    getEndTime: function() {
      return moment
        .utc(this.demandData.last_datetime, "YYYY/MM/DD HH:mm:ss")
        .format("HH:mm");
    },
    isLatestGraph: function() {
      var ret = false;
      if (this.$store.state.demand_datetime == "") {
        ret = true;
      }
      return ret;
    }
  },
  methods: {
    setControlValue: function(data) {
      console.log("setControlValue");
      const target_date = new Date(data.measure[data.measure.length - 1].datetime);
      const target_minutes = target_date.getMinutes();
      if (data.contract_power < this.forcastPowor) {
        if (this.currentPower <= data.contract_power) {
          const remaining_time = 30 - (target_minutes % 30);
          if (remaining_time > 0) {
            this.demand_control = Math.round((this.forcastPowor - data.contract_power) * 30 / remaining_time);
          } else {
            this.demand_control = this.forcastPowor - data.contract_power;
          }
        } else {
          // デマンド現在値（デマンド実績）＞デマンド目標値の場合、抑制のグラフ、必要抑制量を非表示とする
          this.demand_control = 0;
        }
      } else {
        this.demand_control = 0;
      }
    },

    drawDemandChart: function(data) {
      /* 電力デマンド予測 */
      console.log(`drawDemandChart`);

      const self = this;
      let demand_performance = [];
      let demand_forecast = [];
      let demand_caution = [];
      let demand_alarm = [];
      let alarm_demand_forecast = [];
      let demand_power = [];
      let caution_power = [];
      let limit_power = [];
      let demand_control = [];
      let line_length = 7;
      let labels = ["0", "5", "10", "15", "20", "25", "30"];
      if (this.demandData.measure_instrument == 2 || this.demandData.measure_instrument == 3) {
        line_length = 31;
        labels = ["0", "1", "2", "3", "4", "5","6"
                , "7", "8", "9", "10", "11", "12"
                , "13", "14", "15", "16", "17", "18"
                , "19","20", "21", "22", "23", "24"
                , "25", "26","27", "28", "29", "30"];
      }

      data.demand.forEach(element => {
        demand_forecast.push(element.power);
      });

      // this.forcastPowor = 10;

      data.measure.forEach(element => {
        demand_performance.push(element.power);
      });

      this.currentPower = demand_performance.slice(-1)[0];

      if (demand_forecast.length == 0) {
        this.forcastPowor = this.currentPower;
      } else {
        this.forcastPowor = demand_forecast.slice(-1)[0];
      }
      if (this.$store.state.demand_datetime == "") {
        this.$store.dispatch("setDemandPower", this.forcastPowor); // ヘッダ現在値
      }
      this.nowTimed = (30 - demand_forecast.length);

      demand_forecast = demand_performance.concat(demand_forecast);

      for (let index = 0; index < line_length; index++) {
        demand_alarm.push(data.alarm_threshold);
      }

      for (let index = 0; index < line_length; index++) {
        demand_caution.push(data.caution_threshold);
      }

      for (let index = 0; index < line_length; index++) {
        demand_power.push(data.contract_power);
      }

      for (let index = 0; index < line_length; index++) {
        caution_power.push(data.caution_power);
      }

      for (let index = 0; index < line_length; index++) {
        limit_power.push(data.limit_power);
      }

      if (this.demandGraphType != 1) {
        alarm_demand_forecast = demand_performance.slice(0, line_length - data.alarm_demand.length);
        data.alarm_demand.forEach(element => {
          alarm_demand_forecast.push(element.power);
        });
      }
      if (data.alarm_demand.length == 0) {
        this.alarmForcastPowor = data.measure[data.measure.length - 1].power;
      } else {
        this.alarmForcastPowor = data.alarm_demand[data.alarm_demand.length - 1].power;
      }
      this.alarmTimed = (line_length - 1 - data.alarm_demand.length);

      if (this.nowTimed < 30) {
        this.totalControlPower = this.alarmForcastPowor - this.forcastPowor;
      } else {
        this.totalControlPower = this.alarmForcastPowor - this.currentPower;
      }
      this.nowControlPower = alarm_demand_forecast[alarm_demand_forecast.length - 1] - demand_forecast[demand_forecast.length - 1];
      if (this.nowControlPower < 0) {
        this.nowControlPower = 0;
      }

      const demand_time = data.demand_time.split(" ")[1];

      if (this.$store.state.demand_datetime == "") {
        this.$store.dispatch("setCurrentPower", this.currentPower); // ヘッダ予測値
      }

      const lastValue = self.forcastPowor;

      let alertLevel = 1;
      if (this.demandGraphType == 3 && data.air_conditioner_id_count > 0) {
        this.$store.dispatch("setAirConditionerIdFlag", true);
        if (data.control_status == 1) {
          alertLevel = 3;
        } else if (data.control_status == 2) {
          alertLevel = 2;
        } else {
          alertLevel = 1;
        }
      } else {
        this.$store.dispatch("setAirConditionerIdFlag", false);
        if (lastValue >= data.alarm_threshold) {
          alertLevel = 3;
        } else if (lastValue >= data.caution_threshold) {
          alertLevel = 2;
        } else {
          alertLevel = 1;
        }
      }
      this.alertLevelClass = `level${alertLevel}`;
      
      if (this.$store.state.demand_datetime == "") {
        this.$store.dispatch("setAlertLevelClass", this.alertLevelClass);
      }

      console.log(`data.alarm_threshold= %o`, data.alarm_threshold);
      console.log(`data.caution_threshold= %o`, data.caution_threshold);
      console.log(`data.alertLevelClass= %o`, this.alertLevelClass);
      console.log(`demand_forecast= %o`, demand_forecast);
      console.log(`demand_performance= %o`, demand_performance);
      for (let index = demand_performance.length; index < demand_forecast.length - 1; index++) {
        demand_forecast[index] = null;
      }
      for (let index = (line_length - data.alarm_demand.length); index < (alarm_demand_forecast.length - 1); index++) {
        alarm_demand_forecast[index] = null;
      }
      let alarm_demand_forecast_hidden_flg = Boolean(true);
      if (alarm_demand_forecast[alarm_demand_forecast.length - 1] > 0) {
        alarm_demand_forecast_hidden_flg = false;
      }
      
      console.log(`demand_forecast= %o`, demand_forecast);
      console.log(`demand_performance= %o`, demand_performance);
      demand_control = demand_forecast.slice(0, demand_forecast.length - 1);
      demand_control.push(data.contract_power);
      console.log(`demand_control= %o`, demand_control);
      var demand_kw_min = data.power_min; //kWの最小値
      var demand_kw_max = data.power_max; //kWの最大値
      var demand_kw_step = 10; //kWの表示間隔
      if (demand_kw_max > 100) {
        demand_kw_step = Math.floor(demand_kw_max / 100) * 10;
      }
      let demand_control_hidden_flg = Boolean(true);
      if (this.forcastPowor > data.contract_power) {
        demand_control_hidden_flg = false;
        if (this.currentPower > data.contract_power) {
          // デマンド現在値（デマンド実績）＞デマンド目標値の場合、抑制のグラフ、必要抑制量を非表示とする
          demand_control_hidden_flg = true;
        }
      }

      var a;
      // $(window).on("load", function () {

      // });
      var c1 = {
        labels: labels,
        datasets: [
          {
            type: "line",
            label: "デマンド実績",
            data: demand_performance,
            borderColor: "rgba(50,100,255,1.0)",
            pointBackgroundColor: "rgba(255,255,255,0.8)",
            fill: true,
            backgroundColor: "rgba(49, 99, 255, 0.1)",
            pointBorderWidth: 3,
            pointRadius: 4,
            spanGaps: true
          },
          {
            type: "line",
            label: "デマンド予測",
            data: demand_forecast,
            borderColor: "rgba(206,133,255,1.0)",
            pointBackgroundColor: "rgba(255,255,255,0.8)",
            fill: false,
            pointBorderWidth: 3,
            pointRadius: 4,
            spanGaps: true
          },
          {
            type: "line",
            label: "デマンド抑制制御",
            data: demand_control,
            borderColor: "rgba(0,255,0,1.0)",
            pointBackgroundColor: "rgba(255,255,255,0.8)",
            fill: false,
            pointBorderWidth: 3,
            pointRadius: 4,
            spanGaps: true,
            hidden: demand_control_hidden_flg
          },
          {
            type: "line",
            label: "注意閾値",
            data: demand_caution,
            borderColor: "rgba(252,187,149,1.0)",
            fill: false,
            pointRadius: 0,
            pointHoverRadius: 0,
            pointHitRadius: 0
          },
          {
            type: "line",
            label: "警報閾値",
            data: demand_alarm,
            borderColor: "rgba(246,166,166,1.0)",
            fill: false,
            pointRadius: 0,
            pointHoverRadius: 0,
            pointHitRadius: 0
          },
          {
            type: "line",
            label: "デマンド目標値",
            data: demand_power,
            borderColor: "rgba(129,210,239,1.0)",
            fill: false,
            pointRadius: 0,
            pointHoverRadius: 0,
            pointHitRadius: 0
          }
        ]
      };
      var c2 = {
        labels: labels,
        datasets: [
          {
            type: "line",
            label: "デマンド実績",
            data: demand_performance,
            borderColor: "rgba(50,100,255,1.0)",
            pointBackgroundColor: "rgba(255,255,255,0.8)",
            fill: true,
            backgroundColor: "rgba(49, 99, 255, 0.1)",
            pointBorderWidth: 3,
            pointRadius: 4,
            spanGaps: true
          },
          {
            type: "line",
            label: "デマンド予測",
            data: demand_forecast,
            borderColor: "rgba(206,133,255,1.0)",
            pointBackgroundColor: "rgba(255,255,255,0.8)",
            fill: false,
            pointBorderWidth: 3,
            pointRadius: 4,
            spanGaps: true
          },
          {
            type: "line",
            label: "警報時デマンド予測",
            data: alarm_demand_forecast,
            borderColor: "rgba(150,150,150,1.0)",
            pointBackgroundColor: "rgba(255,255,255,0.8)",
            fill: false,
            pointBorderWidth: 3,
            pointRadius: 4,
            spanGaps: true,
            borderDash: [10, 10],
            hidden: alarm_demand_forecast_hidden_flg
          },
          {
            type: "line",
            label: "デマンド抑制制御",
            data: demand_control,
            borderColor: "rgba(0,255,0,1.0)",
            pointBackgroundColor: "rgba(255,255,255,0.8)",
            fill: false,
            pointBorderWidth: 3,
            pointRadius: 4,
            spanGaps: true,
            hidden: demand_control_hidden_flg
          },
          {
            type: "line",
            label: "注意閾値",
            data: demand_caution,
            borderColor: "rgba(252,187,149,1.0)",
            fill: false,
            pointRadius: 0,
            pointHoverRadius: 0,
            pointHitRadius: 0
          },
          {
            type: "line",
            label: "警報閾値",
            data: demand_alarm,
            borderColor: "rgba(246,166,166,1.0)",
            fill: false,
            pointRadius: 0,
            pointHoverRadius: 0,
            pointHitRadius: 0
          },
          {
            type: "line",
            label: "デマンド目標値",
            data: demand_power,
            borderColor: "rgba(129,210,239,1.0)",
            fill: false,
            pointRadius: 0,
            pointHoverRadius: 0,
            pointHitRadius: 0
          }
        ]
      };
      var c3 = {
        labels: labels,
        datasets: [
          {
            type: "line",
            label: "デマンド実績",
            data: demand_performance,
            borderColor: "rgba(50,100,255,1.0)",
            pointBackgroundColor: "rgba(255,255,255,0.8)",
            fill: true,
            backgroundColor: "rgba(49, 99, 255, 0.1)",
            pointBorderWidth: 3,
            pointRadius: 4,
            spanGaps: true
          },
          {
            type: "line",
            label: "デマンド予測",
            data: demand_forecast,
            borderColor: "rgba(206,133,255,1.0)",
            fill: false,
            pointBorderWidth: 3,
            pointRadius: 4,
            spanGaps: true
          },
          {
            type: "line",
            label: "警報時デマンド予測",
            data: alarm_demand_forecast,
            borderColor: "rgba(150,150,150,1.0)",
            pointBackgroundColor: "rgba(255,255,255,0.8)",
            fill: false,
            pointBorderWidth: 3,
            pointRadius: 4,
            spanGaps: true,
            borderDash: [10, 10],
            hidden: alarm_demand_forecast_hidden_flg
          },
          {
            type: "line",
            label: "注意電力",
            data: caution_power,
            borderColor: "rgba(252,187,149,1.0)",
            fill: false,
            pointRadius: 0,
            pointHoverRadius: 0,
            pointHitRadius: 0
          },
          {
            type: "line",
            label: "限界電力",
            data: limit_power,
            borderColor: "rgba(246,166,166,1.0)",
            fill: false,
            pointRadius: 0,
            pointHoverRadius: 0,
            pointHitRadius: 0
          },
          {
            type: "line",
            label: "目標電力",
            data: demand_power,
            borderColor: "rgba(129,210,239,1.0)",
            fill: false,
            pointRadius: 0,
            pointHoverRadius: 0,
            pointHitRadius: 0
          }
        ]
      };
      var b = {
        responsive: true,
        maintainAspectRatio: false,
        legend: false,
        legendCallback: function(e) {
          var f = [];
          f.push('<ul class="' + e.id + '-legend">');
          for (var d = 0; d < e.data.datasets.length; d++) {
            if (e.data.datasets[d].label == "デマンド抑制制御") {
              continue;
            }
            f.push("<li><span>");
            if (e.data.datasets[d].label) {
              f.push(e.data.datasets[d].label);
            }
            f.push("</span></li>");
          }
          f.push("</ul>");
          return f.join("");
        },
        elements: {
          line: {
            tension: 0
          }
        },
        scales: {
          xAxes: [
            {
              ticks: {
                maxRotation: 0,
                minRotation: 0
              },
              gridLines: {
                display: false,
                drawOnChartArea: false
              }
            }
          ],
          yAxes: [
            {
              display: true,
              ticks: {
                max: demand_kw_max,
                min: demand_kw_min,
                stepSize: demand_kw_step
              }
            }
          ]
        },
        tooltips: {
          enabled: false,
          custom: function(m) {
            if (m.opacity === 0) {
              $("#demand-tooltip").css("opacity", 0);
              return;
            }

            function h(n) {
              return n.lines;
            }

            if (m.body) {
              var i = m.body.map(h);
              var time;
              var demands;
              var xPoint;
              var yPoint;

              i.forEach(function(n) {
                time = n[0];
                demands = n[1];
                xPoint = n[2];
                yPoint = n[3];
              });
            }

            var tooltip = document.getElementById("demand-tooltip");
            var innerHtml = "";
            innerHtml += "<dl>";
            innerHtml += ("<dt><span style=\"font-size:20px;\">" + time + "</span></dt>");
            innerHtml += "<table>";
            innerHtml += "<tbody>";
            demands.forEach(function(info) {
              innerHtml += "<tr>";
              innerHtml += ("<td style=\"width:135px; text-align:left;\">" + info[0] + "</td>");
              innerHtml += ("<td style=\"text-align:right;\"><span style=\"font-size:24px;\">" + info[1] + "</span>kW</td>");
              innerHtml += "</tr>";
            });
            innerHtml += "</tbody>";
            innerHtml += "</table>";
            innerHtml += "</dl>";
            tooltip.innerHTML = innerHtml;
            var e = this._chart.canvas.getBoundingClientRect();
            var g = e.left + window.pageXOffset + parseFloat(xPoint) - $("#demand-tooltip").outerWidth() / 2;
            var f = e.top + window.pageYOffset + parseFloat(yPoint) - $("#demand-tooltip").outerHeight() - 20;
            $("#demand-tooltip").css({
              display: "block",
              opacity: 1,
              position: "absolute",
              left: g,
              top: f,
              pointerEvents: "none"
            });
          },
          callbacks: {
            label: function(f, g) {
              var time = "";
              var cur_datetime=new Date(data.demand_time);
              cur_datetime.setSeconds(cur_datetime.getSeconds() + Number(g.labels[f.index])*60);
              time = ("00" + cur_datetime.getHours().toString()).slice(-2) + ":" + ("00" + cur_datetime.getMinutes().toString()).slice(-2);

              var demands = [];
              if ((f.datasetIndex == 2) && (f.index == (g.datasets[2].data.length - 1)) && (g.datasets[2].label == "警報時デマンド予測")) {
                demands.push(["警報時デマンド予測", g.datasets[2].data[g.datasets[2].data.length - 1]]);
              } else if ((f.index == (g.datasets[f.datasetIndex].data.length - 1)) && (g.datasets[f.datasetIndex].label == "デマンド抑制制御")){
                demands.push(["デマンド抑制制御", g.datasets[f.datasetIndex].data[f.index]]);
              } else if (g.datasets[0].data.length == g.datasets[1].data.length) {
                demands.push(["デマンド実績", g.datasets[0].data[f.index]]);
              } else if ((f.index == (g.datasets[1].data.length - 1)) && (g.datasets[0].data.length < g.datasets[1].data.length)) {
                demands.push(["デマンド予測", g.datasets[1].data[g.datasets[1].data.length - 1]]);
              } else {
                demands.push(["デマンド実績", g.datasets[0].data[f.index]]);
                demands.push(["デマンド予測", g.datasets[1].data[g.datasets[1].data.length - 1]]);
              }
              d = [time, demands, f.x, f.y];

              return d;
            }
          }
        }
      };

      var d = document.getElementById("demand_canvas").getContext("2d");
      if (this.chart != null) {
        this.chart.destroy();
      }

      var obj_id = "demand_legend";
      var demand_legend = document.querySelector("#demand_legend");
      if (this.demandGraphType == 1) {
        obj_id = "demand_legend_1";
        this.chartDemand = new Chart(d, { type: "line", data: c1, options: b });
      } else {
        if (this.demandGraphType == 2) {
          obj_id = "demand_legend_2";
          this.chartDemand = new Chart(d, { type: "line", data: c2, options: b });
        } else {
          obj_id = "demand_legend_3";
          this.chartDemand = new Chart(d, { type: "line", data: c3, options: b });
        }
      }
      demand_legend.innerHTML = this.chartDemand.generateLegend();
      demand_legend.id = obj_id;
    }
  },
  mounted: function() {
    //
    console.log(`mounted`);

    if (`${Store.state.demand_datetime}` == "") {
      this.intervalId = setInterval(function() {
        console.log("reload");
        location.reload();
      }, Store.state.reloadTime);
    }
    const self = this;
    this.$axios
      .get(`/srv/api/demand/${Store.state.childID}${Store.state.demand_datetime}`, {
        withCredentials: true
      })
      .then(response => {
        console.log(`demand=`);
        console.log(response.data);
        self.demandData = response.data;
        if (this.demandData.measure_instrument == 1) {
          self.demandGraphType = 1;
        } else {
          if ((this.demandData.air_conditioner_control == true) && (this.demandData.air_conditioner_id_count > 0)) {
            self.demandGraphType = 3;
          } else {
            self.demandGraphType = 2;
          }
        }
        self.drawDemandChart(self.demandData);
        if (this.demandGraphType != 3) {
          self.setControlValue(self.demandData);
        }
      })
      .catch(error => {
        // console.warn("demand error");
        console.log(error);
        // this.$store.dispatch("logout");
        // this.$router.push("/login");
      });
  },
  beforeDestroy() {
    console.log("clearInterval");
    if (this.intervalId != null) {
      clearInterval(this.intervalId);
    }
  }
};
</script>
